import { TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  image: {
    maxWidth: "100px",
    height: "auto",
  },
}));

export default function ReportsTableCell({
  columns,
  element,
  index,
  setTableData,
}) {
  const classes = useStyles();

  return (
    <>
      <TableRow
        hover
        className={classes.rowCell}
        key={index}
        component={Link}
        to={{ pathname: "/marketreport/reportuser", state: element }}
        style={{ background: index % 2 ? "rgba(0,0,0,.08)" : "white" }}
      >
        {columns.map((column, elementIndex) => (
          <TableCell align="left" key={elementIndex}>
            {element[column.propName]}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
